<template>
  <div class="my-2">
    <v-expansion-panels>
        <v-expansion-panel>
        <v-expansion-panel-header class="grey lighten-5">Настройки расчета по пикам</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-data-table :headers="headersPsycho" :items="editedItem.scales" :items-per-page="-1" hide-default-footer>
            <template v-slot:item.peak="{ item }">
                <v-simple-checkbox :ripple="false" :value="Boolean(item.peak)" @input="item.peak=$event" color="primary" />
            </template>
            <template v-slot:item.down="{ item }">
                <v-simple-checkbox :ripple="false" :value="Boolean(item.down)" @input="item.down=$event" color="primary" :disabled="!item.peak" />
            </template>
            <template v-slot:item.limit="{ item }">
                <v-simple-checkbox :ripple="false" :value="Boolean(item.limit)" @input="item.limit=$event" color="primary" :disabled="!item.peak" />
            </template>
            <template v-slot:item.rank="{ item }">
                <v-text-field flat outlined dense class="rank-edit" hide-details v-model="item.rank" :disabled="!item.peak" :error-messages="rankError(item)" />
                <span class="error-text" v-if="rankError(item)">{{rankError(item)}}</span>
            </template>
            </v-data-table>
        </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
        <v-expansion-panel-header class="grey lighten-5">Настройки расчета по диапазонам</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-data-table :headers="headersDiapazon" :items="editedItem.scales2" :items-per-page="-1" hide-default-footer>
            <template v-slot:item.minimum="{ item }">
                <v-text-field flat outlined dense class="rank-edit" hide-details v-model="item.norm_min" :error-messages="rankError2(item, item.norm_min)" />
                <span class="error-text" v-if="rankError2(item, item.norm_min)">{{rankError2(item, item.norm_min)}}</span>
            </template>
            <template v-slot:item.from="{ item }">
                <v-text-field flat outlined dense class="rank-edit" hide-details v-model="item.from_value" :error-messages="rankError2(item, item.from_value)" />
                <span class="error-text" v-if="rankError2(item, item.from_value)">{{rankError2(item, item.from_value)}}</span>
            </template>
            <template v-slot:item.till="{ item }">
                <v-text-field flat outlined dense class="rank-edit" hide-details v-model="item.to_value" :error-messages="rankError2(item, item.to_value)" />
                <span class="error-text" v-if="rankError2(item, item.to_value)">{{rankError2(item, item.to_value)}}</span>
            </template>
            <template v-slot:item.maximum="{ item }">
                <v-text-field flat outlined dense class="rank-edit" hide-details v-model="item.norm_max" :error-messages="rankError2(item, item.norm_max)" />
                <span class="error-text" v-if="rankError2(item, item.norm_max)">{{rankError2(item, item.norm_max)}}</span>
            </template>
            <template v-slot:item.rank="{ item }">
                <v-text-field flat outlined dense class="rank-edit" hide-details v-model="item.decreasing_value" :error-messages="rankError2(item, item.decreasing_value)" />
                <span class="error-text" v-if="rankError2(item, item.decreasing_value)">{{rankError2(item, item.decreasing_value)}}</span>
            </template>
            </v-data-table>
        </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  props: {
    editedItem: Object,
  },
  data() {
    return {
      headersPsycho: [
        { text: 'Наименование', align: 'start', sortable: false, value: 'name' },
        { text: 'Пик', sortable: false, align: 'center', value: 'peak' },
        { text: 'Пик вниз', sortable: false, align: 'center', value: 'down' },
        { text: 'Ограничение', sortable: false, align: 'center', value: 'limit' },
        { text: 'Ранг', sortable: false, align: 'left', value: 'rank' },
      ],
      headersDiapazon: [
        { text: 'Наименование', align: 'start', sortable: false, value: 'name' },
        { text: 'Минимум', sortable: false, align: 'center', value: 'minimum' },
        { text: 'Попадание от', sortable: false, align: 'center', value: 'from' },
        { text: 'Попадание до', sortable: false, align: 'center', value: 'till' },
        { text: 'Максимум', sortable: false, align: 'left', value: 'maximum' },
        { text: 'Уменьшение', sortable: false, align: 'left', value: 'rank' },
      ],

    }
  },
  methods: {
    rankError(sc) {
      const { rank } = sc;
      if (+rank === 0) return;
      const identical = this.editedItem.scales.filter((el) => el.id !== sc.id).find((el) => +el.rank === +rank);
      if (identical) {
        return 'Ранг должен быть уникальным';
      }
    },
    rankError2(sc, value) {
      if (isNaN(value) || +value<0 || +value>100)
        return 'Введите число от 0 до 100';
    },

  }
}

</script>


<style lang="css" scoped>
.rank-edit {
  width: 80px;
}
</style>
